import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const IndustriesBuilders = () => {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => { if (entry.isIntersecting) entry.target.classList.add('reveal-show'); });
    }, { threshold: 0.1 });
    document.querySelectorAll('.reveal-card').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);
  return (
    <>
      <div className="business-hero" style={{ background: 'linear-gradient(135deg, #1e40af, #2563eb)' }}>
        <div className="hero-content">
          <h1 className="hero-title reveal-text">Infrastructure & Development</h1>
          <p className="hero-subtitle reveal-text delay-1">Building the future with world-class infrastructure and sustainable development</p>
        </div>
      </div>
      <div className="business-wrapper">
        <div className="container">
          <div className="category">
            <div className="category-header orange"><h2>Our Infrastructure Company</h2><p>Creating landmarks and shaping skylines across the nation</p></div>
            <div className="card-grid">
              <div className="business-card orange reveal-card"><h3>AALI BUILDERS</h3><p>Premier infrastructure development company building world-class residential and commercial projects</p><Link to="/companies/aalibuilders">Know More →</Link></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default IndustriesBuilders;